import { ContentType } from 'src/app/content-management/shared/enums/content-type';

export interface IRelatedContent {
  contentId: number;
  title: string;
  deliveryTargetCodes: string[];
  deliveryTargetCode?: string;
  link?: string;
  deliveryTargetName?: string;
  contentType?: ContentType;
}

export class RelatedContent implements IRelatedContent {
  constructor(
    public contentId: number,
    public title: string,
    public deliveryTargetCodes: string[],
    public deliveryTargetCode?: string,
    public link?: string,
    public deliveryTargetName?: string,
    public contentType?: ContentType,
  ) {}
}
